import { render, staticRenderFns } from "./SendRequestDate.vue?vue&type=template&id=23765368"
import script from "./SendRequestDate.vue?vue&type=script&lang=ts"
export * from "./SendRequestDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports